export const inventoryImport = [
  {
    Status: ["Available"],
    "Item Name": "Little Blue Van",
    SKU: "LBV-101",
    Notes: "Max payload 595 kg \nMax load length 1620 mm",
    tableId: "ta_bb_inventory",
    "Created At": "2022-11-10T19:11:40.141Z",
    "Updated At": "2022-11-10T20:05:04.608Z",
    type: "row",
    "Purchase Date": "2022-10-10T12:00:00.000",
    "Purchase Price": 39995,
    "Item Tags": ["Vehicle"],
  },
  {
    Status: ["Available"],
    "Item Name": "Masonry Drill",
    SKU: "ABC-123",
    Notes: "Making a burning smell",
    tableId: "ta_bb_inventory",
    "Created At": "2022-11-10T18:46:10.820Z",
    "Updated At": "2022-11-10T20:11:23.766Z",
    type: "row",
    "Purchase Date": "1992-11-19T12:00:00.000",
    "Item Tags": ["Electrical", "Tools"],
    "Purchase Price": 250,
  },
  {
    Status: ["Repair"],
    "Item Name": "Circular saw",
    SKU: "AB2-100",
    Notes: "Won't start",
    tableId: "ta_bb_inventory",
    "Created At": "2022-11-10T19:04:38.805Z",
    "Updated At": "2022-11-10T20:20:24.000Z",
    type: "row",
    "Purchase Date": "2012-11-15T12:00:00.000",
    "Item Tags": ["Electrical"],
    "Purchase Price": 300,
  },
  {
    "Item Tags": ["Electrical"],
    "Purchase Price": 210,
    "Purchase Date": "2022-10-17T12:00:00.000",
    Status: ["Available"],
    "Item Name": "Tablet Device (5g)",
    SKU: "PH-001",
    Notes: "Android tablet for use on site",
    tableId: "ta_bb_inventory",
    "Created At": "2022-11-10T20:21:56.332Z",
    "Updated At": "2022-11-10T20:21:56.332Z",
    type: "row",
  },
  {
    "Item Tags": ["Tools", "Electrical"],
    "Purchase Price": 200,
    "Purchase Date": "2022-10-12T12:00:00.000",
    Status: ["Available"],
    "Item Name": "Power Screwdriver",
    SKU: "TKIT-002-A",
    Notes: "Requires micro USB charger",
    tableId: "ta_bb_inventory",
    "Created At": "2022-11-10T20:10:51.129Z",
    "Updated At": "2022-11-10T20:13:37.821Z",
    type: "row",
  },
  {
    Status: ["Available"],
    "Item Name": "Large Blue Van",
    SKU: "LBV-102",
    Notes: "Max load length 4256 mm",
    tableId: "ta_bb_inventory",
    "Created At": "2022-11-10T19:03:41.698Z",
    "Updated At": "2022-11-10T20:04:57.932Z",
    type: "row",
    "Purchase Date": "2022-10-10T12:00:00.000",
    "Purchase Price": 65995,
    "Item Tags": ["Vehicle"],
  },
  {
    "Purchase Price": 2500,
    "Purchase Date": "2022-11-09T12:00:00.000",
    Status: ["Available"],
    "Item Name": "Office laptop",
    SKU: "PC-123-ABC",
    Notes: "Office Laptop \n",
    tableId: "ta_bb_inventory",
    "Created At": "2022-11-10T20:06:14.463Z",
    "Updated At": "2022-11-10T20:07:02.532Z",
    type: "row",
    "Item Tags": ["Electrical", "Office"],
  },
  {
    Status: ["Available"],
    "Item Name": "Little Red Van",
    SKU: "LRV-904-VNQ",
    Notes: "Max payload 595 kg \nMax load length 1620 mm",
    tableId: "ta_bb_inventory",
    "Created At": "2022-11-10T19:55:02.367Z",
    "Updated At": "2022-11-10T20:05:13.504Z",
    type: "row",
    "Purchase Date": "2022-07-17T12:00:00.000",
    "Purchase Price": 39995,
    "Item Tags": ["Vehicle"],
  },
]
